import { appColours } from '../styles/colours';

export const applyTheme = (themeName = 'default') => {
  if (typeof document === 'undefined' || !document.documentElement) {
    return;
  }

  const resolvedTheme = themeName || 'default';
  const palette = appColours(resolvedTheme);

  document.documentElement.setAttribute('data-theme', resolvedTheme);
  document.documentElement.style.setProperty('--app-page-bg', palette.appBackground || '#a1e0ff');
  document.documentElement.style.setProperty('--theme-submit-bg', palette.icons || '#1890ff');
  document.documentElement.style.setProperty('--theme-submit-text', palette.font2 || '#ffffff');
};
